import React, { FC } from 'react';
import {
  Typography,
  Button,
  Box,
} from '@mui/material';
import Typography500 from 'views/common/components/UI/Typography500';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import StyledBox from 'views/rebranded-module/common/components/UI/ParticipatingLocations/LocationCard/LocationCard.styles';
import { RiMapPin2Line, RiExternalLinkLine } from 'react-icons/ri';

import {
  Typography700,
} from 'views/rebranded-module/common/components';

const LocationCard: FC<any> = (props) => {
  const {
    id,
    title,
    location,
    address,
    link,
    activeCard,
    target,
    content,
    handleLocationCardButtonClick = () => {},
  } = props;
  return (
    <StyledBox
      id={`item_${id}`}
      className={`${activeCard ? 'LCActive' : ' '} `}
      onClick={() => {
        handleLocationCardButtonClick(id);
      }}
    >
      <Typography700 component="p" variant="h7" mb={2.75}>
        {title}
      </Typography700>
      <NavigatorLink
        href={link}
        underline="none"
        className="LCAdressLink"
        target={target|| '_blank'}>
        <RiMapPin2Line className="LCAddressIcon" />
        <Box>
          <Typography
            className="LCAdressLabel"
            variant="overline3"
            component="p"
              >
            {content.adressLabel}
          </Typography>
          <Typography500 variant="body2" component="p">
            {' '}
            {address}
            {' '}
          </Typography500>
        </Box>
      </NavigatorLink>
      <Box className="LCActionsContainer">
        <Button
          size="large"
          component={NavigatorLink}
          href={location}
          color="primary"
          variant="text"
          target={target|| '_blank'}
          endIcon={<RiExternalLinkLine className="LCActionIcon" />}
          className="LCAction"
          >
          {content.locationButtonLabel}
        </Button>
      </Box>

    </StyledBox>
  );
};

export { LocationCard };